import { EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'
import * as BarcodeScanner from '@utils/Barcode/barcodeScanner'
export const reset = () => {
    if (EnvironmentDetail.isAndroid()) {
        return BarcodeScanner.resetBarcodeScannerProfile()
    }
}

/**
 * Sends SCAN_STOP_REQUEST to the React Native shell to dismiss the camera
 * scan button. Called on tool navigation to clean up scanning state when
 * the active tool is being switched. Safe to call unconditionally — the
 * native stopPolling() is idempotent (no-ops if not polling).
 */
export const stopScan = () => {
    if ((window as any).ReactNativeWebView) {
        (window as any).ReactNativeWebView.postMessage(
            JSON.stringify({ type: 'SCAN_STOP_REQUEST' }),
        )
    }
}
